import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrBF: CultureInfo = {
  name: 'fr-BF',
  displayName: 'français (Burkina Faso)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-BF',
  parent: CultureInfoFr
};
